import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { InputNumberInputEvent, InputNumberModule } from 'primeng/inputnumber';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-percentage',
  imports: [InputNumberModule, FormsModule],
  templateUrl: './percentage.component.html',
})
export class PercentageComponent implements OnInit, OnDestroy {
  @Input() name?: string = '';
  @Input() placeholder?: string = '';
  @Input() fluid? = false;
  @Input() control!: FormControl;
  value?: number;
  valueChangeSubscription?: Subscription;

  ngOnInit() {
    // Handle initial value with proper rounding to avoid floating point issues
    const initialValue = this.control.value;
    this.value = (initialValue !== null && initialValue !== undefined)
      ? Math.round(initialValue * 100 * 100) / 100  // Round to 2 decimals
      : 0;

    this.valueChangeSubscription = this.control.valueChanges.subscribe(
      (value) => {
        // Apply same rounding to avoid 55.00000000000001% display issues
        this.value = (value !== null && value !== undefined)
          ? Math.round(value * 100 * 100) / 100  // Round to 2 decimals
          : 0;
      },
    );
  }
  updateFormControl(event: InputNumberInputEvent) {
    if (typeof event === 'number' && !isNaN(event)) {
      this.control.setValue(event / 100);
    }
  }
  ngOnDestroy() {
    this.valueChangeSubscription?.unsubscribe();
  }
}
